import { Routes } from '@angular/router';
import { AuthenticateComponent } from './authenticate/authenticate.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { appAuthGuard } from './_shared/guards/app-auth.guard';
import { loginAuthGuard } from './_shared/guards/login-auth.guard';
import { fuelManagementRoutes } from './fuel-management/fuel-management.routes';
import { driverManagementRoutes } from './driver-management/driver-management.routes';
import { assetManagementRoutes } from './asset-management/asset-management.routes';
import { settingsRoutes } from './settings/settings.routes';

export const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [loginAuthGuard] },
  ...driverManagementRoutes,
  ...fuelManagementRoutes,
  ...assetManagementRoutes,
  ...settingsRoutes,
  {
    path: 'control-tower',
    loadChildren: () =>
      import('./controltower/controltower.routes').then(
        (m) => m.controltowerRoutes
      ),
    canActivate: [appAuthGuard],
  },
  {
    path: 'authenticate',
    component: AuthenticateComponent,
    canActivate: [appAuthGuard],
  },
  { path: 'logout', component: LogoutComponent, canActivate: [appAuthGuard] },
  { path: '', redirectTo: '/driver-management', pathMatch: 'full' },
  { path: '**', redirectTo: '/driver-management' },
];
